import { render, staticRenderFns } from "./AccessTokensManager.vue?vue&type=template&id=fced246a&"
import script from "./AccessTokensManager.vue?vue&type=script&lang=js&"
export * from "./AccessTokensManager.vue?vue&type=script&lang=js&"
import style0 from "./AccessTokensManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports